/* PDX product page behaviour.
   Reads <script type="application/json" data-pdx-config> inside the .pdx root.
   Rules implemented here (from the handoff):
   - Default = highest-priced AVAILABLE one-time offer that has a valid Whop plan.
   - One-time purchase is always the default mode; subscription is opt-in and
     only offered when the selected bundle has a real recurring plan.
   - Prices are rendered only inside the offer cards (and the cart drawer).
   - Savings copy is computed from the store's own smallest bundle (per-unit
     math). Compare-at prices stay hidden unless config.showCompare === true.
   - A "buy X, get Y free" tag is shown only when the maths holds.
   - Add to cart adds a line and opens the drawer. It never navigates.
*/
(function () {
  var root = document.querySelector('.pdx[data-pdx]');
  if (!root) return;
  var cfgEl = root.querySelector('script[data-pdx-config]');
  var cfg = JSON.parse(cfgEl.textContent);
  var S = cfg.strings || {};
  var nativeCart = cfg.checkoutMode === 'shopify';
  var PLAN = /^plan_[A-Za-z0-9]+$/;

  // Liquid mode: join Shopify variants with the existing whop_offers setting
  // (same JSON format as the deployed miren-pdp section, keyed by variant id).
  if (!cfg.offers && cfg.variants) {
    var whop = {};
    try { whop = typeof cfg.whopOffers === 'string' ? JSON.parse(cfg.whopOffers || '{}') : (cfg.whopOffers || {}); } catch (e) { whop = {}; }
    cfg.offers = cfg.variants.map(function (v) {
      var o = whop[String(v.id)] || {};
      var parts = String(v.title).split(' — ');
      var units = o.units || parseInt(v.title, 10) || 1;
      var label = parts[0], promo = (parts[1] || '').trim();
      var m = /^(\d+)\s+\S+/.exec(label);
      if (m && cfg.unit) label = m[1] + ' ' + (+m[1] === 1 ? cfg.unit.one : cfg.unit.other);
      if (/^\d+\s+\S+$/.test(promo) || /^buy 1$/i.test(promo)) promo = '';
      if (promo) promo = promo.charAt(0).toUpperCase() + promo.slice(1);
      return {
        variantId: v.id, title: v.title, label: label, promo: promo, units: units,
        priceCents: nativeCart ? v.price : (Number.isInteger(o.priceCents) ? o.priceCents : 0), compareCents: o.compareCents || 0,
        planId: o.planId || '', available: v.available !== false,
        recurring: !nativeCart && o.recurringPlanId && o.recurringPriceCents ? { planId: o.recurringPlanId, priceCents: o.recurringPriceCents, frequency: o.frequency || '' } : null
      };
    });
  }
  var fmt = new Intl.NumberFormat(cfg.locale || 'fr-FR', { style: 'currency', currency: cfg.currency || 'EUR' });
  var money = function (c) { return fmt.format(c / 100); };
  var t = function (k, vars) { var s = S[k] || k; if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); }); return s; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
  var unitWord = function (n) { return n === 1 ? (cfg.unit && cfg.unit.one) || '' : (cfg.unit && cfg.unit.other) || ''; };

  var offers = cfg.offers.map(function (o, i) {
    return Object.assign({ idx: i, buyable: !!(o.available !== false && (nativeCart ? !!o.variantId : PLAN.test(o.planId || '')) && o.priceCents > 0) }, o);
  });
  var mode = 'once';

  // ---------- Offer maths ----------
  var base = offers.slice().sort(function (a, b) { return a.units - b.units; })[0];
  var baseUnit = base ? base.priceCents / base.units : 0;
  function priceOf(o) { return mode === 'sub' && o.recurring ? o.recurring.priceCents : o.priceCents; }
  function perUnit(o) { return Math.round(priceOf(o) / Math.max(1, o.units)); }
  function promoValid(o) {
    if (!o.promo) return false;
    var m = /buy\s*(\d+)[^\d]+(?:get\s*)?(?:the\s*)?(\d+)/i.exec(o.promo) || /achet\w*\s*(\d+)[^\d]+(\d+)/i.exec(o.promo);
    if (!m) return true; // descriptive tag ("the essential"), nothing to verify
    var paid = parseInt(m[1], 10);
    if (!base || base.units !== 1) { o.promoUnverified = true; return false; }
    var ok = o.priceCents <= paid * base.priceCents;
    if (!ok) console.warn('[pdx] promo tag suppressed, maths does not hold:', o.title, o.priceCents, '>', paid * base.priceCents);
    return ok;
  }
  offers.forEach(function (o) { o.showPromo = promoValid(o); });
  var lowestPer = offers.length > 1 ? offers.reduce(function (m, o) { return !m || o.priceCents / o.units < m.priceCents / m.units ? o : m; }, null) : null;

  // ---------- Render offer cards ----------
  var list = root.querySelector('[data-px-offer-list]');
  function metaFor(o) {
    var parts = [];
    if (o.units > 1 || cfg.alwaysPerUnit) parts.push(t('perUnit', { price: money(perUnit(o)), unit: unitWord(1) }));
    if (mode === 'once' && base && o !== base && o.units > base.units) {
      var pct = Math.round((1 - (o.priceCents / o.units) / baseUnit) * 100);
      if (pct >= 1) parts.push(t('lessPer', { pct: pct, unit: unitWord(1), base: base.label }));
    }
    if (mode === 'sub' && o.recurring) parts.push(o.recurring.frequency);
    if (!parts.length && offers.length === 1 && mode === 'once' && !anyRecurring && S.onceNote) parts.push(S.onceNote);
    return parts.join(' · ');
  }
  function renderOffers() {
    lowestPer = offers.length > 1 ? offers.filter(function (o) { return mode === 'once' || o.recurring; }).reduce(function (m, o) { return !m || priceOf(o) / o.units < priceOf(m) / m.units ? o : m; }, null) : null;
    list.innerHTML = offers.map(function (o) {
      var disabled = o.available === false || (mode === 'sub' && !o.recurring);
      var tag = o.showPromo ? o.promo : (lowestPer === o && offers.length > 1 && o.units > 1 ? t('lowestPer', { unit: unitWord(1) }) : '');
      var cmp = cfg.showCompare && o.compareCents > priceOf(o) ? '<s>' + money(o.compareCents) + '</s>' : '';
      return '<label class="px-offer' + (disabled ? ' is-disabled' : '') + '" data-offer="' + o.idx + '">' +
        '<input type="radio" name="px-offer" value="' + esc(o.variantId) + '"' + (disabled ? ' disabled' : '') + '>' +
        '<span class="px-radio" aria-hidden="true"></span>' +
        '<span><span class="px-offer-name">' + esc(o.label) + '</span>' +
        '<span class="px-offer-meta">' + esc(metaFor(o)) + '</span>' +
        (tag ? '<span class="px-offer-tag">' + esc(tag) + '</span>' : '') + '</span>' +
        '<span class="px-offer-price"><strong>' + money(priceOf(o)) + '</strong>' + cmp + '</span></label>';
    }).join('');
  }

  // ---------- Default selection ----------
  function pickDefault() {
    var pool = offers.filter(function (o) { return o.buyable; });
    if (!pool.length) pool = offers.filter(function (o) { return o.available !== false; });
    return pool.reduce(function (b, o) { return !b || o.priceCents > b.priceCents ? o : b; }, null);
  }
  var selected = pickDefault();

  // ---------- Purchase mode ----------
  var modeWrap = root.querySelector('[data-px-mode]');
  var disclosure = root.querySelector('[data-px-disclosure]');
  var anyRecurring = offers.some(function (o) { return o.recurring && PLAN.test(o.recurring.planId || ''); });
  if (modeWrap) modeWrap.hidden = !anyRecurring;

  // ---------- Apparel ----------
  var piecesWrap = root.querySelector('[data-px-pieces]');
  var choices = {};
  function renderPieces() {
    if (!piecesWrap || !cfg.apparel) return;
    var n = selected ? selected.units : 1;
    var opt = function (arr, ph, cur) { return '<option value="">' + esc(ph) + '</option>' + arr.map(function (v) { return '<option' + (v === cur ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join(''); };
    var rows = '';
    for (var i = 1; i <= n; i++) {
      var c = choices[i] || {};
      rows += '<div class="px-piece"><span>' + esc(t('item', { n: i })) + '</span>' +
        '<select class="px-select" data-piece="' + i + '" data-kind="color" aria-label="' + esc(t('colorOf', { n: i })) + '">' + opt(cfg.apparel.colors, t('color'), c.color) + '</select>' +
        '<select class="px-select" data-piece="' + i + '" data-kind="size" aria-label="' + esc(t('sizeOf', { n: i })) + '">' + opt(cfg.apparel.sizes, t('size'), c.size) + '</select></div>';
    }
    piecesWrap.querySelector('[data-px-piece-rows]').innerHTML = rows;
  }
  function piecesDetails() {
    if (!cfg.apparel || !selected) return { ok: true, text: '' };
    var out = [], ok = true;
    for (var i = 1; i <= selected.units; i++) {
      var c = choices[i] || {};
      if (!c.color || !c.size) ok = false;
      out.push(t('item', { n: i }) + (cfg.locale && cfg.locale.indexOf('fr') === 0 ? ' : ' : ': ') + (c.color || '?') + ' / ' + (c.size || '?'));
    }
    return { ok: ok, text: out.join(' · ') };
  }

  // ---------- State paint ----------
  var addBtn = root.querySelector('[data-px-add]');
  var blocked = root.querySelector('[data-px-blocked]');
  function paint() {
    renderOffers();
    var radio = selected && list.querySelector('[data-offer="' + selected.idx + '"] input');
    if (radio) radio.checked = true;
    list.querySelectorAll('.px-offer').forEach(function (el) { el.classList.toggle('is-selected', selected && +el.getAttribute('data-offer') === selected.idx); });
    if (modeWrap) {
      var subInput = modeWrap.querySelector('input[value="sub"]');
      var can = selected && selected.recurring && PLAN.test(selected.recurring.planId || '');
      subInput.disabled = !can;
      subInput.closest('label').title = can ? '' : t('noSub');
      if (!can && mode === 'sub') { mode = 'once'; modeWrap.querySelector('input[value="once"]').checked = true; renderOffers(); }
    }
    if (disclosure) {
      var on = mode === 'sub' && selected && selected.recurring;
      disclosure.hidden = !on;
      if (on) disclosure.textContent = t('subDisclosure', { price: money(selected.recurring.priceCents), freq: selected.recurring.frequency.toLowerCase() });
    }
    var buyable = selected && selected.buyable;
    addBtn.disabled = !buyable;
    if (blocked) blocked.hidden = !!buyable;
    renderPieces();
  }

  list.addEventListener('change', function (e) {
    if (e.target.name !== 'px-offer') return;
    var o = offers.find(function (x) { return String(x.variantId) === e.target.value; });
    if (o) { selected = o; paint(); }
  });
  if (modeWrap) modeWrap.addEventListener('change', function (e) {
    if (e.target.name !== 'px-mode') return;
    mode = e.target.value;
    if (mode === 'sub' && !(selected && selected.recurring)) {
      var alt = offers.filter(function (o) { return o.recurring; }).sort(function (a, b) { return b.priceCents - a.priceCents; })[0];
      if (alt) selected = alt;
    }
    paint();
  });
  if (piecesWrap) piecesWrap.addEventListener('change', function (e) {
    var p = e.target.getAttribute('data-piece'); if (!p) return;
    choices[p] = choices[p] || {}; choices[p][e.target.getAttribute('data-kind')] = e.target.value;
    var hint = piecesWrap.querySelector('[data-px-piece-hint]'); if (hint && piecesDetails().ok) hint.hidden = true;
  });

  // ---------- Add to cart (never navigates) ----------
  function currentLine() {
    if (!selected || !selected.buyable) return null;
    var sub = mode === 'sub' && selected.recurring;
    var planId = sub ? selected.recurring.planId : selected.planId;
    if (!nativeCart && !PLAN.test(planId)) return null;
    var p = piecesDetails();
    return {
      planId: planId, variantId: selected.variantId, productTitle: cfg.productTitle,
      offerTitle: selected.label, title: cfg.productTitle + ' · ' + selected.title + (sub ? ' · ' + selected.recurring.frequency : '') + (p.text ? ' · ' + p.text : ''),
      details: p.text, priceCents: sub ? selected.recurring.priceCents : selected.priceCents,
      frequency: sub ? selected.recurring.frequency : '', image: cfg.image, recurring: !!sub, quantity: 1
    };
  }
  async function addToCart(e) {
    if (e) e.preventDefault();
    var p = piecesDetails();
    if (!p.ok) {
      var hint = piecesWrap.querySelector('[data-px-piece-hint]'); if (hint) hint.hidden = false;
      var first = [].slice.call(piecesWrap.querySelectorAll('select')).find(function (s) { return !s.value; });
      if (first) first.focus();
      return;
    }
    var line = currentLine(); if (!line || !window.PdxCart) return;
    addBtn.disabled = true;
    try { await window.PdxCart.add(line); window.PdxCart.open(); }
    catch (err) { window.PdxCart.open(); window.PdxCart.error(err.message); }
    finally { addBtn.disabled = false; }
    if (window.whop && window.whop.track) { try { window.whop.track('add_to_cart', { value: line.priceCents / 100, currency: cfg.currency }); } catch (err) {} }
  }
  addBtn.addEventListener('click', addToCart);

  // ---------- Gallery ----------
  var track = root.querySelector('[data-px-slides]');
  var thumbs = [].slice.call(root.querySelectorAll('[data-px-thumb]'));
  var counter = root.querySelector('[data-px-counter]');
  var slides = track ? [].slice.call(track.children) : [];
  function goTo(i) { if (!track) return; i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); mark(i); }
  function mark(i) { thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); if (counter) counter.textContent = (i + 1) + ' / ' + slides.length; cur = i; }
  var cur = 0;
  thumbs.forEach(function (b, i) { b.addEventListener('click', function () { goTo(i); }); });
  var prev = root.querySelector('[data-px-prev]'), next = root.querySelector('[data-px-next]');
  if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
  if (next) next.addEventListener('click', function () { goTo(cur + 1); });
  if (track) {
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }); }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goTo(cur + 1); if (e.key === 'ArrowLeft') goTo(cur - 1); });
  }

  // ---------- Sticky quick buy ----------
  var sticky = document.querySelector('[data-px-sticky]');
  var stickyBtn = document.querySelector('[data-px-sticky-btn]');
  var offersBox = root.querySelector('[data-px-offers]');
  var below = true;
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var r = en[0]; below = r.boundingClientRect.top > 0;
      sticky.classList.toggle('is-visible', !r.isIntersecting);
      stickyBtn.textContent = below ? t('chooseOffer') : t('addToCart');
    }).observe(addBtn);
    stickyBtn.addEventListener('click', function () {
      if (below) offersBox.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      else addToCart();
    });
  }

  // ---------- Review placeholders (unpublished preview only) ----------
  var ph = document.querySelector('[data-px-placeholders]');
  var phToggle = document.querySelector('[data-px-ph-toggle]');
  if (ph) {
    var showPh = /[?&]preview=reviews\b/.test(location.search);
    ph.hidden = !showPh;
    if (phToggle) { phToggle.checked = showPh; phToggle.addEventListener('change', function () { ph.hidden = !phToggle.checked; }); }
  }

  paint();
  if (window.whop && window.whop.track) { try { window.whop.track('view_content', { content_name: cfg.productTitle, currency: cfg.currency }); } catch (e) {} }
  root.setAttribute('data-ready', '');
})();
